export default {
  createSuccess: "¡Vendedor creado correctamente!",
  createModal: {
    title: "Añadir vendedor",
    namePlaceholder: "p. ej. Acme Tours",
    emailPlaceholder: "seller@example.com",
    create: "Crear vendedor",
  },
  detail: {
    loadSeller: "Cargando datos del vendedor...",
    loadError: "No se pudo cargar el vendedor",
    roleLabel: "Vendedor",
    statActivities: "Actividades",
    bookingsCardTitle: "Reservas",
    seeBookings: "Ver reservas",
    toastPasswordResetSent: "Correo de restablecimiento enviado al vendedor.",
    activitiesTitle: "Actividades ({{count}})",
    addActivity: "Añadir actividad",
    loadActivities: "Cargando actividades...",
    activitiesError: "Error al cargar las actividades",
    noActivitiesTitle: "Sin actividades",
    noActivitiesDesc: "Este vendedor aún no tiene actividades",
    toastStatusUpdated: "Estado del vendedor actualizado",
    toastStatusError: "No se pudo actualizar el estado",
    categoryRestaurant: "Restaurante",
    categoryService: "Servicio",
    categoryAttraction: "Atracción",
    activityCommission: "Comisión",
  },
} as const;
